<style lang="less" scoped>
</style>
<template>
  <VRemoteSelect
    v-bind="$attrs"
    item-value="id"
    :item-text="(c) => (`${c.shop_platform}-${c.shop_name}`)"
    :find_api="$util.api.third_party_shop_detail"
    :search_api="$util.api.third_party_shop_select_list"
    :item-default="{id: 0, shop_platform: '', shop_name: ''}"
    v-on="$listeners"
  />
</template>
<script>
import VRemoteSelect from '@/vuetify_custom/v-remote-select.vue';

export default {
  components: {VRemoteSelect},
  inheritAttrs: false,
}
</script>
